import type { ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";

import { HeaderEl } from "./Modal.styles";
import type { ModalHeaderProps } from "./Modal.types";
import { useModalContext } from "./ModalContext";

const ModalHeaderComponent = (props: ModalHeaderProps): ReactElement => {
  const { children, content, className, style, id } = props;
  const { titleId, basic } = useModalContext();
  return (
    <HeaderEl
      id={id ?? titleId}
      className={cx(className)}
      style={style}
      $basic={basic}
    >
      {children ?? content}
    </HeaderEl>
  );
};

export const ModalHeader = styled(ModalHeaderComponent)``;
